module.exports = " <input type=number :class=classes v-model=data tabindex=0 :autofocus=autofocus /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/IntegerFieldtype.vue
// module id = 690
// module chunks = 0